import { IAddSchool, IListSchool } from "../../types/request_data/schools";
export const schoolJSON = {
  listSchool: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    searchTerm,
    classDepth,
    state,
    className,
  }: IListSchool) => {
    return {
      pageNo: pageNo,
      limit: limit ? limit : "",
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount:  true ,
      searchTerm: searchTerm,
      classDepth: classDepth,
      state: state,
      class: className,
    };
  },
  editSchool: ({
    name,
    address,
    adminName,
    classDetails,
    academicYear,
    academicSession,
    city,
    state,
    postalCode,
    country,
    phone,
    email,
    user,
    lat,
    lng,
    image,
    thumbnail,
  }: IAddSchool) => {
    const temp: any = {
      name: name,
      phone: phone,
      address: address,
      adminName: adminName,
      city: city,
      state: state,
      postalCode: postalCode,
      country: country,
      email: email,
      phoneCountry: "+255",
      lat: lat,
      lng: lng,
    };

    if (image) {
      temp.image = image?.split(".com/")[1];
      temp.thumbnail = thumbnail?.split(".com/")[1];
    }

    if (user) {
      temp.userReference = user.reference;
    }

    if (classDetails) {
      temp.class = classDetails.map((item: any) => ({
        reference: item.reference,
      }));
    }
    if (academicSession && academicSession?.length) {
      academicYear = [...academicSession, ...academicYear];
    }
    if (academicYear) {
      temp.academicYear = academicYear.map((item: any) => ({
        reference: item._id,
      }));
    }
    return temp;
  },
  addSchool: ({
    name,
    address,
    adminName,
    classDetails,
    academicYear,
    city,
    state,
    postalCode,
    country,
    phone,
    phoneCountry,
    email,
    image,
    lat,
    lng,
    thumbnail,
  }: IAddSchool) => {
    const school = {
      name: name,
      phone: phone,
      phoneCountry: phoneCountry,
      address: address,
      adminName: adminName,
      class: classDetails.map((ref: any) => ({
        reference: ref.reference,
      })),
      academicYear: academicYear.map((ref: any) => ({
        reference: ref.reference,
      })),
      city: city,
      state: state,
      postalCode: postalCode,
      country: country,
      email: email,
      lat: lat,
      lng: lng,
      image: image.split(".com/")[1],
      thumbnail: thumbnail.split(".com/")[1],
    };
    return school;
  },
};
